module.exports = __webpack_public_path__ + "static/img/pager.49e0807.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/icons/pager.jpg
// module id = 8Pg5
// module chunks = 1